module.exports = __webpack_public_path__ + "img/audio-white.efe6b85f.svg";